/**
 * Утилиты для работы с конфигурациями
 */

// Определяет тип значения для правильного отображения поля
export const detectFieldType = (value: any): string => {
  if (value === null || value === undefined) {
    return 'string';
  }

  const type = typeof value;

  if (type === 'boolean') {
    return 'boolean';
  }

  if (type === 'number') {
    return 'number';
  }

  if (type === 'string') {
    // Проверяем, является ли строка датой в формате ISO
    if (/^\d{4}-\d{2}-\d{2}T/.test(value)) {
      return 'date';
    }
    return 'string';
  }

  if (type === 'object' && !Array.isArray(value)) {
    return 'object';
  }

  return 'string';
};

// Преобразует плоскую структуру формы в вложенный объект
export const flattenObjectToFormValues = (obj: any, prefix: string[] = []): any => {
  const result: any = {};

  Object.keys(obj).forEach(key => {
    const value = obj[key];
    const path = [...prefix, key];

    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(result, flattenObjectToFormValues(value, path));
    } else {
      result[path.join('.')] = value;
    }
  });

  return result;
};

// Преобразует значения формы обратно в вложенный объект
export const formValuesToNestedObject = (values: any): any => {
  const result: any = {};

  Object.keys(values).forEach(key => {
    const parts = key.split('.');
    let current = result;

    parts.forEach((part, index) => {
      if (index === parts.length - 1) {
        current[part] = values[key];
      } else {
        current[part] = current[part] || {};
        current = current[part];
      }
    });
  });

  return result;
};

// Проверяет, является ли поле только для чтения
export const isReadOnlyField = (fieldName: string): boolean => {
  const readOnlyFields = ['loaded', 'tenantId'];
  return readOnlyFields.includes(fieldName);
};

// Валидация JSON
export const validateJSON = (obj: any): { valid: boolean; error?: string } => {
  try {
    // Проверяем, что объект можно сериализовать
    JSON.stringify(obj);
    return { valid: true };
  } catch (error) {
    return { valid: false, error: (error as Error).message };
  }
};
